module.exports = __webpack_public_path__ + "img/kairan.6865c4b3.png";